/**
 * The items a row drag carries: a selected row carries the whole selection,
 * an unselected row only itself. Under select-all-matching the selection
 * isn't loaded, so a selected row carries nothing and doesn't drag.
 */
export function resolveRowDragItems<TItem>({
    item,
    isSelected,
    selectedItems,
    isSelectAll,
}: {
    item: TItem;
    isSelected: boolean;
    selectedItems: TItem[];
    isSelectAll: boolean;
}): TItem[] {
    if (!isSelected) {
        return [item];
    }
    return isSelectAll ? [] : selectedItems;
}
